import React, { useState, useEffect, useRef } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { REGEX } from '../../constants/regex';
const phoneNumberRegex = REGEX.PHONENUMBER;
const PhoneNumberInput = ({value, onchange, placeholder, invalidMessage, country, options, hasError, disabled}) => {
    const [selectedCountry, setSelectedCountry] = useState(country);
    const [phoneNumber, setPhoneNumber] = useState(value);
    const [isValid, setIsValid] = useState(true);
    const [countries, setCountries] = useState([]);
    const maxLength = 15;
    const phoneInput = useRef(false);
    useEffect(() => {
        const setOptions = async () => {
          if (!selectedCountry) {
            handleSelectedCountryCode(options.find(op => op.isDefault === true));
          }
          setCountries(options);
        }
        setOptions();
    }, [options]);


  const convertPhoneNumber = (phoneNumber) => {
        if (typeof phoneNumber === 'string' && phoneNumber.startsWith('0') && phoneNumber.length > 1) {
            return phoneNumber.substring(1);
        }
        return phoneNumber;
    }

  const handlePhoneChange = (e) => {
    const value = convertPhoneNumber(e.target.value);
    
    if (value.length > maxLength) {
      return;
    }
    setPhoneNumber(value);

    let isValidNumber = true;
    if (!value) {
      isValidNumber = false
    }
    else{
      isValidNumber = phoneNumberRegex.test(value);
    }
    setIsValid(isValidNumber);
    const updatedData = {
      data: {dialCode: selectedCountry.phoneCode},
      value: value,
    };
    if (!isValidNumber) {
      updatedData.value = ''
    }

    onchange(updatedData);
  };

  const handleSelectedCountryCode = (value) => {
    setSelectedCountry(value);
    const updatedData = {
      value: phoneNumber,
      data: {country: value}
    };
    onchange(updatedData);
  }

  const countryOptionTemplate = (option) => {
    return (
      <div className="justify-content-start align-items-center flex gap-1">
        <div className="keduall-icon flag-circle-country small-size justify-content-center align-items-center flex">
            <span className={`flag img flex fi fi-${option.code.toLowerCase()}`} />
        </div>
        <div className="flex keduall-typography text-16-normal-400 text-default-txt">{option.phoneCode}</div>
      </div>
    );
  };

  // Figma (648-5359): the collapsed phone-code field shows the dial code only
  // (no flag). Flags remain in the open dropdown list via countryOptionTemplate.
  const selectedCountryTemplate = (option, props) => {
    if (option) {
      return (
        <div className="justify-content-start align-items-center flex gap-1">
          <div className="flex keduall-typography text-16-normal-400 text-default-txt">{option.phoneCode}</div>
        </div>
      );
    }
    return <span>{props.placeholder}</span>;
  };

  return (
    (countries.length > 0 && 
        (<div className="flex flex-row gap-075">
            <div ref={phoneInput} className="flex height-fit">
              <Dropdown
                id="phoneCode"
                value={selectedCountry}
                options={countries}
                onChange={(e) => handleSelectedCountryCode(e.value)}
                optionLabel="phoneCode"
                filter
                showClear={false}
                valueTemplate={selectedCountryTemplate}
                itemTemplate={countryOptionTemplate}
                panelClassName='w-min keduall-form dropdown-input-panel keduall-scrollbar keduall-typography text-16-normal-400 text-default-txt'
                className="keduall-form dropdown-input self dropdown-content-container custom-dropdown p-075"
                appendTo={"self"}
                disabled={disabled}
              />
            </div>
            <div className="flex w-full flex-column">
              <div className="flex w-full">
                <InputText
                  id="phone"
                  value={phoneNumber}
                  onChange={handlePhoneChange}
                  size={15}
                  placeholder={placeholder}
                  disabled={disabled}
                  className={`${(!isValid || hasError) ? 'p-invalid' : ''} text-default-txt keduall-typography text-16-normal-400 keduall-form input-default-default w-full`}
                />
              </div>
              {(!isValid || hasError) && (
                <small className="flex p-error">{invalidMessage}</small>
              )}
            </div>
          </div>)
    )
    
  );
};

export default PhoneNumberInput;